// utils/caseConverter.ts

export const toCamelCase = <T>(obj: any, excludeKeys?: string[]): T => {
  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCase(item, excludeKeys)) as any;
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      const newKey = excludeKeys?.includes(key)
        ? key
        : key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

      acc[newKey] = toCamelCase(value, excludeKeys);
      return acc;
    }, {} as Record<string, any>) as T;
  }
  return obj;
};

export const toSnakeCase = <T>(obj: any, excludeKeys?: string[]): T => {
  if (Array.isArray(obj)) {
    return obj.map((item) => toSnakeCase(item, excludeKeys)) as any;
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const rawValue = obj[key];

      if (excludeKeys?.includes(key)) {
        acc[key] = rawValue;
      } else {
        const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        acc[newKey] = toSnakeCase(rawValue, excludeKeys);
      }

      return acc;
    }, {} as Record<string, any>) as T;
  }

  return obj;
};
